import request from './interceptor'

/**
 * 获取清运记录列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getCleaningLogsList(params) {
  return request({
    url: '/v1/cleaning-logs',
    method: 'get',
    params
  })
}

/**
 * 获取清运记录详情
 * @param {Number|String} id - 清运记录ID
 * @returns {Promise}
 */
export function getCleaningLogDetail(id) {
  return request({
    url: `/v1/cleaning-logs/${id}`,
    method: 'get'
  })
}

/**
 * 创建清运记录
 * @param {Object} data - 清运记录数据
 * @returns {Promise}
 */
export function createCleaningLog(data) {
  return request({
    url: '/v1/cleaning-logs',
    method: 'post',
    data
  })
}

/**
 * 更新清运记录
 * @param {Number|String} id - 清运记录ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export function updateCleaningLog(id, data) {
  return request({
    url: `/v1/cleaning-logs/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除清运记录
 * @param {Number|String} id - 清运记录ID
 * @returns {Promise}
 */
export function deleteCleaningLog(id) {
  return request({
    url: `/v1/cleaning-logs/${id}`,
    method: 'delete'
  })
}
